<template>
  <main-layout>
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Utilisateurs</span>
        <div class="pl-1" v-if="!isFetchingUsers">({{ users.length }})</div>
        <v-spacer></v-spacer>
      </v-row>
      <div class="page-main-content">
        <v-row no-gutters justify="center" align="center" class="mb-4">
          <v-col class="py-2search-bar border-component">
            <v-text-field
              v-model="searchString"
              outlined
              dense
              placeholder="Rechercher un utilisateur..."
              prepend-inner-icon="search"
              hide-details
              clearable
            />
          </v-col>
          <div class="pl-4">
            <v-row no-gutters justify="center" align="center">
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <div class="ml-2 primary--text font-weight-bold">
                {{ currentPage + 1 }} / {{ nbPages }}
              </div>
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-row>
          </div>
        </v-row>
        <n-card depressed>
          <v-row no-gutters justify="center" align="center" class="py-8" style="min-height: 100px;" v-if="isFetchingUsers">
            <div style="width: 250px;">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
          </v-row>
          <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;" v-else-if="!users.length">
            Aucun utilisateur
          </v-row>
          <v-list v-else class="pa-0">
            <template v-for="(user, index) in filteredUsersPaginated">
              <v-list-item
                :key="`user-${index}`"
              >
                <v-list-item-avatar>
                  <v-icon>account_circle</v-icon>
                </v-list-item-avatar>

                <v-row align="center" no-gutters>
                  <v-col align="left">
                    <v-list-item-content>
                      <template v-if="user.$name.length">
                        <v-list-item-title>{{ user.$name }}</v-list-item-title>
                        <v-list-item-subtitle v-if="user.$email.length">
                          {{ user.$email }}
                        </v-list-item-subtitle>
                      </template>
                      <v-list-item-title v-else>{{ user.$email }}</v-list-item-title>
                    </v-list-item-content>
                  </v-col>

                  <v-list-item-action class="ma-0" v-if="user.spaces.length === 1">
                    <v-btn
                      class="n-small-btn n-primary-btn"
                      :href="getUserSpaceSsoUrl(user.spaces[0])"
                      target="_blank"
                    >
                      {{ user.spaces[0].name }}
                      <v-icon right class="ml-2">open_in_new</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action class="ma-0" v-if="user.spaces.length > 1">
                    <v-menu rounded>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="n-small-btn n-secondary-btn"
                        >
                          Plusieurs espaces
                          <v-icon right class="ml-1">expand_more</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <template v-for="(space, spacesIndex) in user.spaces">
                          <v-list-item
                            :key="`user-${index}-space-${spacesIndex}`"
                            :href="getUserSpaceSsoUrl(space)"
                            target="_blank"
                          >
                            {{ space.name }}
                            <v-spacer />
                            <v-icon class="ml-2">open_in_new</v-icon>
                          </v-list-item>
                          <v-divider v-if="spacesIndex + 1 < user.spaces.length" :key="`user-${index}-space-${spacesIndex}-divider`" />
                        </template>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-row>
              </v-list-item>
              <v-divider
                v-if="index + 1 < filteredUsersPaginated.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </n-card>
        <v-row no-gutters justify="center" align="center" class="pt-6">
          <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <div class="ml-2 primary--text font-weight-bold">
            {{ currentPage + 1 }} / {{ nbPages }}
          </div>
          <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>
  </main-layout>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import MainLayout from '@/views/indeegoSettings/MainLayout.vue';

const PAGE_SIZE = 25;

export default {
  data: () => ({
    isFetchingUsers: false,
    searchString: ``,
    currentPage: 0,
  }),
  computed: {
    ...mapState(`ui/indeegoSettingsUsers`, {
      storeUsers: `users`,
    }),
    filteredUsers() {
      let { users } = this;
      if (_.trim(this.searchString) !== ``) {
        this.searchString.split(` `).forEach(searchStringPart => {
          searchStringPart = _.toLower(searchStringPart);
          users = _.filter(users, user =>
            user.$searchString.indexOf(searchStringPart) !== -1
          );
        });
      }
      return users;
    },
    users() {
      return _.chain(this.storeUsers)
        .reject({ slug: `admin` })
        .map(user => {
          const name = _.trim(`${user.firstname} ${user.lastname}`);
          return {
            ...user,
            $name: name,
            $lowerName: name.toLowerCase(),
            $email: _.trim(user.email || ``),
            $searchString: _.toLower(`
              ${user.firstname || ``} ${user.lastname || ``} ${user.email || ``} ${user.username || ``}
            `),
          };
        })
        .filter(user => user.$name !== `` || user.$email !== ``)
        .sortBy([`$lowerName`, `email`])
        .value();
    },
    filteredUsersPaginated() {
      const firstIndex = this.currentPage * PAGE_SIZE;
      return this.filteredUsers.slice(firstIndex, firstIndex + PAGE_SIZE);
    },
    nbPages() {
      return Math.ceil(this.filteredUsers.length / PAGE_SIZE);
    },
  },
  methods: {
    async fetchUsers() {
      this.isFetchingUsers = true;
      await this.$store.dispatch(`ui/indeegoSettingsUsers/fetchUsers`);
      this.isFetchingUsers = false;
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      const newPageIndex = (this.currentPage + 1) * PAGE_SIZE;
      if (newPageIndex < this.filteredUsers.length) {
        this.currentPage += 1;
      }
    },
    getUserSpaceSsoUrl(space) {
      let ssoUrl = `${space.slugUrl}/sso?token=${space.ssoToken}&logout=1`;

      if (ssoUrl.indexOf(`http:`) !== 0) {
        const protocol = window.location.protocol; // eslint-disable-line
        ssoUrl = `${protocol}//${ssoUrl}`;
      }

      return ssoUrl;
    },
  },
  beforeMount() {
    this.fetchUsers();
  },
  components: {
    MainLayout,
  },
};
</script>

<style lang="scss">
</style>
